// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"05bb3637fdff2e26c895","293":"3ebc7ee3642d9a741b0f","518":"86220f9438d903b3b741","779":"ebb5e47624d259068e11"}[chunkId] + ".js";
};